export default __webpack_public_path__ + "aea2d15d43da70a2d3b6288b338c644b.png";